export default __webpack_public_path__ + "img/b085759903428ffd9d346e294f934800.svg";